import PropTypes from 'prop-types';
import {
  AD_TIMING_STATUS,
  ALWAYS_PUBLISHED,
  COUNTRIES,
  EXCLUDE_FROM_DB_REASON,
  GENRE_STATUS,
  GOOD_BAD,
  IAP_SETTINGS,
  IMDB_RANKING,
  LANGUAGE_CODES,
  MPAA_RATING,
  POSTER_16X9_STATUS,
  PUBLIC_DOMAIN,
  QUALITY_CHECK,
  QUALITY_MAX_RESOLUTION,
  REGIONS,
  RESTRICTED_CONTENT,
  RESTRICTED_CONTENT_REASON,
  TRAILER_STATUS,
  TRAILER_STATUS_REASON,
  TRASHY,
  TVOD_PRICE,
  VALID_CONTENT_OWNER_ROLES,
  VIDEO_RESOLUTION,
  VIDEO_STATUS,
  VIDEO_STATUS_REASON,
  VIDEO_TYPES,
} from '../../config/const.config';

const PNMCellLabel = ({ dataKey, value }) => {
  let constObj = '';

  if (dataKey === 'region') {
    const regionName = REGIONS.filter((item) => item.value === value)[0]?.label;
    return regionName;
  }
  if (dataKey === 'country' || dataKey === 'imdb_country') {
    const countryName = COUNTRIES.filter((item) => item.value === value)[0]
      ?.label;
    return countryName;
  }
  if (dataKey === 'video_language') {
    const languageLabel = value ? LANGUAGE_CODES[value]?.label : '-';
    return languageLabel;
  }

  if (dataKey === 'video_type' || dataKey === 'videoType') {
    constObj = VIDEO_TYPES;
  } else if (dataKey === 'resolution') {
    constObj = VIDEO_RESOLUTION;
  } else if (dataKey === 'trashy') {
    constObj = TRASHY;
  } else if (dataKey === 'good_bad' || dataKey === 'goodBad') {
    constObj = GOOD_BAD;
  } else if (dataKey === 'imdb_ranking' || dataKey === 'imdbRanking') {
    constObj = IMDB_RANKING;
  } else if (dataKey === 'mpaa_rating' || dataKey === 'mpaaRating') {
    constObj = MPAA_RATING;
  } else if (
    dataKey === 'restricted_content' ||
    dataKey === 'avod_validated' ||
    dataKey === 'restrictedContent' ||
    dataKey === 'avodValidated'
  ) {
    constObj = RESTRICTED_CONTENT;
  } else if (
    dataKey === 'restricted_content_reason' ||
    dataKey === 'restrictedContentReason'
  ) {
    constObj = RESTRICTED_CONTENT_REASON;
  } else if (
    dataKey === 'exclude_from_db_reason' ||
    dataKey === 'excludeFromDBReason'
  ) {
    constObj = EXCLUDE_FROM_DB_REASON;
  } else if (dataKey === 'ad_timing_status' || dataKey === 'adTimingStatus') {
    constObj = AD_TIMING_STATUS;
  } else if (dataKey === 'genre_status' || dataKey === 'genreStatus') {
    constObj = GENRE_STATUS;
  } else if (
    dataKey === 'quality_max_resolution' ||
    dataKey === 'qualityMaxResolution'
  ) {
    constObj = QUALITY_MAX_RESOLUTION;
  } else if (dataKey === 'public_domain' || dataKey === 'publicDomain') {
    constObj = PUBLIC_DOMAIN;
  } else if (dataKey === 'always_published' || dataKey === 'alwaysPublished') {
    constObj = ALWAYS_PUBLISHED;
  } else if (
    dataKey === 'poster_16x9_status' ||
    dataKey === 'poster16x9Status'
  ) {
    constObj = POSTER_16X9_STATUS;
  } else if (
    dataKey === 'rokuIapSetting' ||
    dataKey === 'webIapSetting' ||
    dataKey === 'firetvIapSetting' ||
    dataKey === 'androidIapSetting' ||
    dataKey === 'appleIapSetting' ||
    dataKey === 'samsungTvIapSetting' ||
    dataKey === 'lgTvIapSetting'
  ) {
    constObj = IAP_SETTINGS;
  } else if (
    dataKey === 'quality_video' ||
    dataKey === 'quality_poster_3x4' ||
    dataKey === 'quality_subtitle' ||
    dataKey === 'quality_description' ||
    dataKey === 'quality_poster_16x9' ||
    dataKey === 'quality_trailer' ||
    dataKey === 'quality_genres' ||
    dataKey === 'quality_categories' ||
    dataKey === 'quality_source_url'
  ) {
    constObj = QUALITY_CHECK;
  } else if (dataKey === 'video_status') {
    constObj = VIDEO_STATUS;
  } else if (dataKey === 'video_status_reason') {
    constObj = VIDEO_STATUS_REASON;
  } else if (dataKey === 'trailer_status') {
    constObj = TRAILER_STATUS;
  } else if (dataKey === 'trailer_status_reason') {
    constObj = TRAILER_STATUS_REASON;
  } else if (dataKey === 'distributor_type') {
    constObj = VALID_CONTENT_OWNER_ROLES;
  } else if (dataKey === 'tvodIap') {
    constObj = TVOD_PRICE;
  }

  return constObj[value] || '-';
};

PNMCellLabel.propTypes = {
  dataKey: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
};

export default PNMCellLabel;
